export const projectData = [
    {
        name: "Nippon Paint Connect (NPC)",
        duration: "Aug 2023 - Present",
        associatedWith: "Nippon Paint (M) Sdn Bhd",
        description: "A comprehensive digital platform connecting stakeholders in the painting ecosystem. Streamlined operations and enhanced user engagement through modern web technologies."
    },
    {
        name: "ATOMS (Orchestration System)",
        duration: "Apr 2019 - July 2023",
        associatedWith: "TIME dotCom Berhad",
        description: "An advanced task orchestration system acting as a mediator for Service Activation, Billing, and Modification. Handles complex workflows from multiple sources including web interfaces and external applications."
    },
    {
        name: "ERIT (Ticket Mediation)",
        duration: "Oct 2018 - July 2023",
        associatedWith: "TIME dotCom Berhad",
        description: "A centralized system for managing Trouble Tickets and Service Requests. migrated legacy activation workflows to ATOMS while maintaining robust ticket management capabilities."
    },
    {
        name: "Master Product Catalog",
        duration: "Jul 2020 - Apr 2022",
        associatedWith: "TIME dotCom Berhad",
        description: "Led the migration and configuration of complex product data from legacy systems to a new architecture. Managed incidents and ensured data integrity across product lifecycles."
    },
    {
        name: "IoT Vertical Farming",
        duration: "Oct 2017 - May 2018",
        associatedWith: "National University of Malaysia (UKM)",
        description: "Developed a smart farming system using IoT sensors to monitor and control environmental conditions for vertical farming, enhancing crop yield and resource efficiency."
    },
    {
        name: "MPOB Family Day System",
        duration: "Jun 2018 - Aug 2018",
        associatedWith: "Malaysian Palm Oil Board",
        description: "Designed and developed an event management system for MPOB's annual family day, handling registration, logistics, and participant data for a large-scale corporate event."
    }
];
